import { render } from "./BusinessSettings.vue?vue&type=template&id=6471927a&scoped=true"
import script from "./BusinessSettings.vue?vue&type=script&lang=js"
export * from "./BusinessSettings.vue?vue&type=script&lang=js"

import "./BusinessSettings.vue?vue&type=style&index=0&id=6471927a&lang=css&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6471927a"]])

export default __exports__